import { NavParams, NavController } from 'ionic-angular';
import { Component, AfterViewInit, OnInit } from '@angular/core';
import { LocalNotificationProvider } from '@providers/local-notification/local-notification';
import { AuthProvider } from '@providers/auth/auth';
import { DesafioEquipoProvider } from '@providers/desafio-equipo/desafio-equipo';
import { EstatusRetoEnum } from '@domain/estatus.reto.enum';
import { PushNotificationProvider } from '@providers/push-notification/push-notification';
import {
  HomeTCPage,
  HomePCPage,
  BusquedaTesoroPage,
  NotificacionesPage,
  MaterialesApoyoPage
} from '@pages';
import { DeviceProvider } from '@providers/device/device';
import { ColorProvider } from '@providers/color/color';
import { Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage implements OnInit, AfterViewInit {

  busquedaTesoro = BusquedaTesoroPage;
  homeTC = HomeTCPage;
  homePC = HomePCPage;
  notificaciones = NotificacionesPage;
  materialesApoyo = MaterialesApoyoPage;
  active: number;

  jugador: any;
  equipo: any;
  ESTATUS_RETO_ENUM = EstatusRetoEnum;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private authProvider: AuthProvider,
    private pushNotificationProvider: PushNotificationProvider,
    private desafioEquipoProvider: DesafioEquipoProvider,
    private deviceProvider: DeviceProvider,
    private localNotificationProvider: LocalNotificationProvider,
    private colorProvider: ColorProvider,
    private events: Events,
    private statusBar: StatusBar
  ) {
    this.active = navParams.get('active') ? navParams.get('active') : 0;
  }

  async ngOnInit() {
    this.jugador = await this.authProvider.getSession();

    this.equipo = await this.authProvider.getEquipo();

    const estatus = await this.desafioEquipoProvider.estatus(this.equipo.area._id, this.equipo._id, this.jugador._id);
    this.localNotificationProvider.createNotificationTeamChallenge(estatus);

    this.pushNotificationProvider.init();
    this.deviceProvider.init();

  }

  ngAfterViewInit(): void {
    this.updateColors();
    this.events.subscribe('color:updated', () => {
      this.updateColors();
    });
  }

  async updateColors() {
    this.colorProvider.renderTabs();

    const color = await this.colorProvider.getPrimaryColor();
    this.statusBar.backgroundColorByHexString(color);
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts